module.exports = __webpack_public_path__ + "img/s1-1-ja.7352366e.jpg";